import { AccountTypeFeePeriod } from '../types/account';

export const SAVINGS_ACCOUNT_PLAIN_FEE_CLASS_CODE = 102;

export const ACCOUNT_TYPE_PERIOD_TEXT = {
  [AccountTypeFeePeriod.Monthly]: 'accountTypePeriod.month',
  [AccountTypeFeePeriod.Withdraw]: 'accountTypePeriod.withdrawal',
};
